// extracted by mini-css-extract-plugin
module.exports = {"VotingButton":"VotingButton_VotingButton__s8BUV","FormAligner":"VotingButton_FormAligner__i0VXJ"};